import React, { useState, useEffect, useCallback } from 'react';
import NovoProduto from './NovoProduto';

const API = process.env.REACT_APP_API_URL || '/api';
async function req(path) {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API}${path}`, { headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) } });
  return res.json();
}
async function apiPatch(path) {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API}${path}`, { method: 'PATCH', headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) } });
  return res.json();
}
async function apiDelete(path) {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API}${path}`, { method: 'DELETE', headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) } });
  return res.json();
}

const BADGE_MAP = { hot: '🔥 HOT', novo: '✨ Novo', ultimas: '⚡ Últimas', esgotado: '🚫 Esgotado' };

export default function StoreProducts() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filterCat, setFilterCat] = useState('');
  const [view, setView] = useState('list'); // 'list' | 'new' | editId
  
  const fetchProducts = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (search) params.set('search', search);
      if (filterCat) params.set('category_id', filterCat);
      const data = await req('/admin/store/products?' + params);
      setProducts(data.products || []);
      setTotal(data.total || 0);
    } catch (e) { console.error(e); }
    setLoading(false);
  }, [search, filterCat]);

  useEffect(() => { req('/admin/store/categories').then(setCategories).catch(() => {}); }, []);
  useEffect(() => { fetchProducts(); }, [fetchProducts]);

  const toggleProduct = async (id) => {
    await apiPatch('/admin/store/products/' + id + '/toggle');
    fetchProducts();
  };

  const deleteProduct = async (id, name) => {
    if (!window.confirm('Remover "' + name + '"?')) return;
    await apiDelete('/admin/store/products/' + id);
    fetchProducts();
  };

  // Mostra formulário de novo/editar produto
  if (view === 'new' || (typeof view === 'number')) {
    return <NovoProduto 
      editId={typeof view === 'number' ? view : undefined} 
      onBack={() => { setView('list'); fetchProducts(); }} 
    />;
  }

  return (
    <div style={{ padding: '1.5rem' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2 style={{ fontSize: '1.3rem', fontWeight: 700, color: 'var(--text-hi)' }}>
          Catálogo da Loja <span style={{ color: 'var(--accent-2)', fontWeight: 400, fontSize: '0.9rem' }}>({total})</span>
        </h2>
        <button onClick={() => setView('new')} style={{ padding: '8px 20px', background: 'var(--accent)', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: '0.82rem', cursor: 'pointer' }}>
          + Novo Produto
        </button>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        <input type="text" placeholder="Buscar produto..." value={search} onChange={e => setSearch(e.target.value)}
          style={{ flex: 1, maxWidth: 300, padding: '8px 12px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 6, color: 'var(--text-hi)', fontSize: '0.85rem' }} />
        <select value={filterCat} onChange={e => setFilterCat(e.target.value)}
          style={{ padding: '8px 12px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 6, color: 'var(--text-mid)', fontSize: '0.82rem' }}>
          <option value="">Todas categorias</option>
          {categories.map(c => <option key={c.id} value={c.id}>{c.icon} {c.name}</option>)}
        </select>
      </div>

      {loading ? <p style={{ color: 'var(--text-lo)' }}>Carregando...</p> : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid var(--border)' }}>
                {['', 'Produto', 'Categoria', 'Preço', 'Estoque', 'Badge', 'No Site', 'Status', ''].map(h =>
                  <th key={h} style={{ padding: '8px 10px', textAlign: 'left', fontSize: '0.72rem', fontWeight: 600, color: 'var(--text-mid)', textTransform: 'uppercase' }}>{h}</th>
                )}
              </tr>
            </thead>
            <tbody>
              {products.map(p => (
                <tr key={p.id} style={{ borderBottom: '1px solid var(--border)', opacity: p.active ? 1 : 0.45 }}>
                  <td style={C}>{p.primary_image && <img src={p.primary_image} alt="" style={{ width: 40, height: 40, objectFit: 'contain', borderRadius: 6, background: 'var(--surface)' }} />}</td>
                  <td style={{ ...C, fontWeight: 600, color: 'var(--text-hi)', maxWidth: 250, cursor: 'pointer' }} onClick={() => setView(p.id)}>
                    <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.name}</div>
                    {p.variant_count > 0 && <span style={{ fontSize: '0.7rem', color: 'var(--accent-2)' }}>{p.variant_count} variações</span>}
                  </td>
                  <td style={C}>{p.category_name}</td>
                  <td style={{ ...C, fontWeight: 700, color: 'var(--accent)' }}>R$ {parseFloat(p.price).toFixed(2)}</td>
                  <td style={C}>{p.stock}</td>
                  <td style={C}>{BADGE_MAP[p.badge] || '—'}</td>
                  <td style={C}>
                    <span style={{ fontSize: '0.7rem', color: p.listar_no_site !== false ? '#34d399' : 'var(--text-lo)' }}>
                      {p.listar_no_site !== false ? '✓ Sim' : '✕ Não'}
                    </span>
                  </td>
                  <td style={C}>
                    <button onClick={() => toggleProduct(p.id)}
                      style={{ padding: '2px 8px', borderRadius: 10, fontSize: '0.68rem', fontWeight: 700, cursor: 'pointer', border: 'none',
                        background: p.active ? 'rgba(37,211,102,0.15)' : 'rgba(239,68,68,0.15)',
                        color: p.active ? '#6ee7b7' : '#fca5a5' }}>
                      {p.active ? 'Ativo' : 'Inativo'}
                    </button>
                  </td>
                  <td style={C}>
                    <div style={{ display: 'flex', gap: 4 }}>
                      <button onClick={() => setView(p.id)} style={{ background: 'none', border: '1px solid var(--border)', borderRadius: 4, color: 'var(--text-mid)', cursor: 'pointer', fontSize: '0.72rem', padding: '2px 8px' }}>Editar</button>
                      <button onClick={() => deleteProduct(p.id, p.name)}
                        style={{ background: 'none', border: 'none', color: 'var(--text-lo)', cursor: 'pointer', fontSize: '0.82rem' }}
                        onMouseEnter={e => e.target.style.color = 'var(--red)'}
                        onMouseLeave={e => e.target.style.color = 'var(--text-lo)'}>✕</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {!products.length && <p style={{ color: 'var(--text-lo)', textAlign: 'center', padding: '2rem' }}>Nenhum produto</p>}
        </div>
      )}
    </div>
  );
}

const C = { padding: '8px 10px', fontSize: '0.82rem', color: 'var(--text-mid)' };
